import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import Container from '@material-ui/core/Container';


const listImages = [
  { id: 1, value: null, title: "FMC650 / FMB640 (DV3-MAX)", text: "Corte de arranque con interruptor de seguridad", pdf: "https://staticcontent.inelcan.com/pdf/Corte-de-arranque-con-interruptor-de-seguridad-FMB640.pdf" },
  { id: 2, value: null, title: "FMC130 (DV1 130) / FMB120 (DV1 120)", text: "Corte de arranque con interruptor de seguridad", pdf: "https://staticcontent.inelcan.com/pdf/Corte-de-arranque-con-interruptor-de-seguridad-FMB120.pdf" },
  { id: 3, value: null, title: "FMC650 / FMB640 (DV3-MAX)", text: "Descarga remota trasera", pdf: "https://staticcontent.inelcan.com/pdf/Descarga-remota-trasera-FMB640.pdf" },
  { id: 4, value: null, title: "FMC130 (DV1 130) / FMB120 (DV1 120)", text: "IButton zumbador con interruptor de seguridad", pdf: "https://staticcontent.inelcan.com/pdf/Ibutton-zumbador-con-interruptor-de-seguridad-FMB120.pdf" },
  { id: 5, value: null, title: "Tacógrafo", text: "Impresión del ticket de tacógrafo", pdf: "https://staticcontent.inelcan.com/pdf/Impresión-de-ticket-de-tacógrafo.pdf" },
  { id: 6, value: null, title: "FMC130 (DV1 130) / FMB120 (DV1 120)", text: "Corte remoto - interruptor de seguridad", pdf: "https://staticcontent.inelcan.com/pdf/Corte-remoto-interruptor-de-seguridad-FMB120.pdf" },
  { id: 7, value: null, title: "EBS", text: "Piña del EBS", pdf: "https://staticcontent.inelcan.com/pdf/Piña-del-EBS.pdf" },
  { id: 8, value: null, title: "Tacografo DV3B", text: "Tacografo DV3B frontal", pdf: "https://staticcontent.inelcan.com/pdf/TACOG_-_DV3B_Frontal.pdf" },
  { id: 9, value: null, title: "FMC650 / FMB640 (DV3-MAX)", text: "Corte de arranque con llave de seguridad", pdf: "https://staticcontent.inelcan.com/pdf/Corte-de-arranque-con-llave-de-seguridad-FMB640.pdf" },
  { id: 10, value: null, title: "Esquema instalación básica ", text: "Esquema instalación básica", pdf: "https://staticcontent.inelcan.com/pdf/Esquema-instalación-básica.pdf" },
];
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  rootCard: {
    maxWidth: 345,
    marginTop: 20
  },
}));


const ManagementManuals = () => {
  const classes = useStyles();

  const clickHandle = (item) => {
    window.open(item.pdf, '_blank', 'noreferrer');
  }

  return (
    <Container maxWidth="lg" >
      <Typography style={{ marginTop: 20 }} gutterBottom variant="h4" component="h3">
        Listado de manuales
      </Typography>
      <Grid container className={classes.root} spacing={0}>
        {listImages.map((item) => (
          <Grid key={item.id} item lg={4} md={4} sm={12} style={{ marginBottom: 20 }}>
            <Card className={classes.rootCard}>
              <CardActionArea rel="noopener noreferrer" onClick={() => clickHandle(item)}>
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    style={{
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                      lineHeight: 1.2,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {item.text}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>

  )
}

export default ManagementManuals

